import React from 'react';
import { useParams } from 'react-router-dom';
import queryString from 'query-string';

import Auth0UserDetailsContainer from '@totem/components/services/remoteAccess/auth0users/details/Auth0UserDetailsContainer';
import Auth0UserDetailsLayout, {
  Auth0UserDetailsExtra,
} from '@totem/components/services/remoteAccess/auth0users/details/Auth0UserDetailsLayout';
import Auth0UserPageTitle from '@totem/components/services/remoteAccess/auth0users/details/Auth0UserPageTitle';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import { Breadcrumb } from '@totem/types/breadcrumb';
import { getCalculatedBreadcrumb } from '@totem/utilities/breadcrumbs';

const Auth0UserDetailsPage = () => {
  const { email } = useParams();

  const getBreadcrumbs = (routeBreadcrumbs: Breadcrumb[]): Breadcrumb[] => {
    const parsed = queryString.parse(location.search);

    if (typeof parsed.from === 'string') {
      const fromBreadcrumb = getCalculatedBreadcrumb(parsed.from);

      if (fromBreadcrumb !== null) {
        // routeBreadcrumbs[0] is always the organization crumb prepended by
        // getBaseRoutes — keep it first, then the "from" origin, then the
        // page's own static breadcrumb(s).
        return [
          routeBreadcrumbs[0],
          fromBreadcrumb,
          ...routeBreadcrumbs.slice(1),
        ];
      }
    }

    return routeBreadcrumbs;
  };

  return (
    <Auth0UserDetailsContainer email={email}>
      <ContentLayout
        pageTitle={<Auth0UserPageTitle />}
        breadcrumbs={getBreadcrumbs}
      >
        <IBCard
          isCovered
          title="User Details"
          extra={<Auth0UserDetailsExtra />}
        >
          <Auth0UserDetailsLayout />
        </IBCard>
      </ContentLayout>
    </Auth0UserDetailsContainer>
  );
};

export default Auth0UserDetailsPage;
